import { useTranslation } from "react-i18next";
import { Button } from "@pracownik/ui";
import { setConsent, useConsent } from "@/lib/consent";

/**
 * Minimal consent notice. Only one optional category exists (error replays),
 * so a two-button banner is honest and sufficient — no dark patterns, equal
 * weight for both choices, dismissible by keyboard.
 */
export function CookieBanner() {
  const { t } = useTranslation("common");
  const consent = useConsent();
  if (consent !== "unset") return null;

  return (
    <div
      role="dialog"
      aria-label={t("consent.title")}
      className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-xl animate-fade-in-up rounded-2xl border bg-card/95 p-4 shadow-elevated backdrop-blur sm:inset-x-auto sm:right-6 sm:bottom-6"
    >
      <p className="text-sm font-medium">{t("consent.title")}</p>
      <p className="mt-1 text-[13px] leading-relaxed text-text-secondary">
        {t("consent.body")}{" "}
        {/* Rendered outside the RouterProvider, so a plain anchor instead of <Link>. */}
        <a href="/privacy" className="underline underline-offset-2 hover:text-foreground">
          {t("consent.learnMore")}
        </a>
      </p>
      <div className="mt-3 flex flex-wrap gap-2">
        <Button size="sm" onClick={() => setConsent("all")}>
          {t("consent.acceptAll")}
        </Button>
        <Button size="sm" variant="outline" onClick={() => setConsent("necessary")}>
          {t("consent.necessaryOnly")}
        </Button>
      </div>
    </div>
  );
}
